/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PrimaryMaterialBlockConsumed } from '../../models/primary-material-block-consumed';

export interface GetConsumption$Params {
  workCenterId: number;
}

export function getConsumption(http: HttpClient, rootUrl: string, params: GetConsumption$Params, context?: HttpContext): Observable<StrictHttpResponse<PrimaryMaterialBlockConsumed>> {
  const rb = new RequestBuilder(rootUrl, getConsumption.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PrimaryMaterialBlockConsumed>;
    })
  );
}

getConsumption.PATH = '/api/v1/PrimaryMaterial/{workCenterId}/Consumption';
